import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import AutoReplenishEmptyHub from 'components/RichProfile/MyAccount/AutoReplenishment/AutoReplenishEmptyHub';
import AutoReplenishmentHub from 'components/RichProfile/MyAccount/AutoReplenishment/AutoReplenishmentHub';
import useAutoReplenishmentPageContent from 'components/RichProfile/MyAccount/AutoReplenishment/AutoReplenishmentPageContent/hooks/useAutoReplenishmentPageContent';

/**
 * Auto Replenishment page content component.
 * Conditionally renders either the empty hub or regular auto replenishment content
 * based on feature flags and user subscription status.
 */
const AutoReplenishmentPageContent = () => {
    const { shouldRenderEmptyHub } = useAutoReplenishmentPageContent();

    return shouldRenderEmptyHub ? <AutoReplenishEmptyHub /> : <AutoReplenishmentHub />;
};

export default wrapFunctionalComponent(AutoReplenishmentPageContent, 'AutoReplenishmentPageContent');
